/** Shared GraphQL slot tree fragment for page draft / version bodies. */
export const PAGE_SLOT_FIELDS = `
  slotId
  components {
    _id
    presetId
    widgetId
    props
    subcomponents {
      _id
      presetId
      widgetId
      props
      subcomponents {
        _id
        presetId
        widgetId
        props
        subcomponents {
          _id
          presetId
          widgetId
          props
          subcomponents {
            _id
            presetId
            widgetId
            props
            subcomponents {
              _id
              presetId
              widgetId
              props
              subcomponents {
                _id
                presetId
                widgetId
                props
              }
            }
          }
        }
      }
    }
  }
`;

export const PAGE_VERSION_SUMMARIES_LIMIT = 50;
